import React from 'react';
import Icon from '../AppIcon';

const ApplicationProgress = ({ currentStep = 1, totalSteps = 5 }) => {
  const steps = [
    { number: 1, label: 'Personal Info', icon: 'User' },
    { number: 2, label: 'Education', icon: 'BookOpen' },
    { number: 3, label: 'Documents', icon: 'FileText' },
    { number: 4, label: 'Language Test', icon: 'Languages' },
    { number: 5, label: 'Review', icon: 'CheckCircle' },
  ];

  const getStepStatus = (stepNumber) => {
    if (stepNumber < currentStep) return 'completed';
    if (stepNumber === currentStep) return 'current';
    return 'upcoming';
  };

  return (
    <div className="w-full bg-card rounded-lg p-6 shadow-warm-sm">
      <div className="mb-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
          Application Progress
        </h3>
        <p className="text-sm text-muted-foreground font-caption">
          Step {currentStep} of {totalSteps}
        </p>
      </div>
      <div className="hidden md:flex items-center justify-between relative">
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-muted">
          <div
            className="h-full bg-primary transition-smooth"
            style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }}
          />
        </div>

        {steps?.map((step, index) => {
          const status = getStepStatus(step?.number);
          return (
            <div key={step?.number} className="flex flex-col items-center relative z-10">
              <div
                className={`
                  w-10 h-10 rounded-full flex items-center justify-center transition-smooth
                  ${
                    status === 'completed'
                      ? 'bg-primary text-primary-foreground'
                      : status === 'current' ?'bg-accent text-accent-foreground ring-4 ring-accent/20' :'bg-muted text-muted-foreground'
                  }
                `}
              >
                {status === 'completed' ? (
                  <Icon name="Check" size={20} />
                ) : (
                  <Icon name={step?.icon} size={20} />
                )}
              </div>
              <span
                className={`
                  mt-2 text-xs font-caption font-medium text-center max-w-[80px]
                  ${
                    status === 'current' ?'text-foreground' :'text-muted-foreground'
                  }
                `}
              >
                {step?.label}
              </span>
            </div>
          );
        })}
      </div>
      <div className="md:hidden space-y-3">
        {steps?.map((step) => {
          const status = getStepStatus(step?.number);
          return (
            <div
              key={step?.number}
              className={`
                flex items-center gap-3 p-3 rounded-md transition-smooth
                ${
                  status === 'current' ?'bg-accent/10 border border-accent'
                    : status === 'completed' ?'bg-primary/5' :'bg-muted/30'
                }
              `}
            >
              <div
                className={`
                  w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0
                  ${
                    status === 'completed'
                      ? 'bg-primary text-primary-foreground'
                      : status === 'current' ?'bg-accent text-accent-foreground' :'bg-muted text-muted-foreground'
                  }
                `}
              >
                {status === 'completed' ? (
                  <Icon name="Check" size={16} />
                ) : (
                  <Icon name={step?.icon} size={16} />
                )}
              </div>
              <div className="flex-1">
                <p
                  className={`
                    text-sm font-medium font-caption
                    ${
                      status === 'current' ?'text-foreground' :'text-muted-foreground'
                    }
                  `}
                >
                  {step?.label}
                </p>
              </div>
              {status === 'current' && (
                <Icon name="ArrowRight" size={16} color="var(--color-accent)" />
              )}
            </div>
          );
        })}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground font-caption">
            Completion
          </span>
          <span className="font-medium text-foreground data-text">
            {Math.round(((currentStep - 1) / totalSteps) * 100)}%
          </span>
        </div>
        <div className="mt-2 h-2 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary transition-smooth"
            style={{ width: `${((currentStep - 1) / totalSteps) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default ApplicationProgress;